import { render, staticRenderFns } from "./user-bookcourse-display.vue?vue&type=template&id=64bee030&scoped=true"
import script from "./user-bookcourse-display.vue?vue&type=script&lang=js"
export * from "./user-bookcourse-display.vue?vue&type=script&lang=js"
import style0 from "./user-bookcourse-display.vue?vue&type=style&index=0&id=64bee030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bee030",
  null
  
)

export default component.exports